import React from 'react'
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { contact } from '../../data/profile';

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href={contact.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
        <BsLinkedin />
      </a>
      <a href={contact.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
        <FaGithub />
      </a>
    </div>
  );
}

export default HeaderSocials
